let globalConfig = {};

const configuration = {
  set: (data) => {
    globalConfig = { ...globalConfig, ...data };
  },
  get: (key) => {
    return key.split('.').reduce((obj, k) => obj && obj[k], globalConfig);
  }
};

export default configuration;
